function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#414141",
  d: "M19.732 3.618H.268A.269.269 0 0 1 0 3.348V2.27C0 2.12.12 2 .268 2h19.464c.148 0 .268.12.268.27v1.078c0 .15-.12.27-.268.27zm0 7.191H.268a.269.269 0 0 1-.268-.27V9.461c0-.15.12-.27.268-.27h19.464c.148 0 .268.12.268.27v1.078c0 .15-.12.27-.268.27zm0 7.191H.268A.269.269 0 0 1 0 17.73v-1.078c0-.15.12-.27.268-.27h19.464c.148 0 .268.12.268.27v1.078c0 .15-.12.27-.268.27z"
});

var SvgMenuInline = function SvgMenuInline(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgMenuInline;